var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_vm._v(" This is a page for all world "),_c('br'),_vm._v(" "+_vm._s(_vm.isSignedIn)+" "),_vm._v(" "+_vm._s(_vm.userInfo)+" "),_c('router-link',{attrs:{"to":"/"}},[_c('br'),_vm._v("Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }